/* eslint-disable import/order */
import '@/@iconify/icons-bundle'
import App from '@/App.vue'
import ability from '@/plugins/casl/ability'
import i18n from '@/plugins/i18n'
import layoutsPlugin from '@/plugins/layouts'
import vuetify from '@/plugins/vuetify'
import { loadFonts } from '@/plugins/webfontloader'
import router from '@/router'
import { getPosthog } from '@/plugins/postHog'
import { abilitiesPlugin } from '@casl/vue'
import * as Sentry from '@sentry/vue'
import '@core/scss/template/index.scss'
import '@styles/styles.scss'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import packageJson from '../package.json'
import { useMainStore } from '@/stores/MainStore'
import { uuidv7 } from 'uuidv7'

loadFonts()

// Create vue app
const app = createApp(App)

const initSentry = posthog => {
  const sentryOrganisationName = import.meta.env.VITE_SENTRY_ORGANISATION_NAME
  const sentryProjectId = import.meta.env.VITE_SENTRY_PROJECT_ID

  if (window.Cypress) {
    window.Sentry = {
      captureException: () => {},
    }

    return
  }

  if (!sentryOrganisationName || !sentryProjectId) {
    throw new Error('Missing required Sentry environment info!')
  }

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),

      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),

      posthog.sentryIntegration({
        organization: sentryOrganisationName,
        projectId: sentryProjectId,
      }),
    ],
    tracesSampleRate: 1.0,

    // TODO needs thought tracePropagationTargets: ['localhost', import.meta.env.VITE_APP_URL],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.VITE_APP_ENVIRONMENT || 'unspecified',
    release: packageJson.version,
  })
}

const initPosthog = () => {
  const mainStore = useMainStore()
  
  mainStore.posthogSessionId = uuidv7()
  console.debug('Posthog Session ID:', mainStore.posthogSessionId)
}

const posthog = getPosthog()

initSentry(posthog)

// Use plugins
app.use(vuetify)
app.use(createPinia())
app.use(router)
app.use(layoutsPlugin)
app.use(i18n)
app.use(abilitiesPlugin, ability, {
  useGlobalProperties: true,
})

initPosthog()

app.config.errorHandler = (error, instance, info) => {
  console.error('Error boundary reached with error', error)

  // TODO Show message in snackbar - rules TBC

  try {
    Sentry.captureException(error)
  } catch (err) {
    console.error('Failed to send Sentry log!', err)
  }
}

app.mount('#app')

console.log(
  `Shopthru Portal version ${packageJson.version} running in environment: ${import.meta.env.VITE_APP_ENVIRONMENT}`,
)
